var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"svg-icon",attrs:{"src":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }